/*
 * Chrome's print "Headers and footers" puts the current ERP URL, date/title
 * and page number into the physical page margin. A document cannot switch that
 * browser preference off, but Chrome does not reserve that header/footer area
 * when the printed @page has zero margin. Keep our visual A4 breathing room as
 * BODY padding instead, so the ledger still has the same 9mm white border while
 * the browser has no margin slot in which to print /contacts, date or page no.
 */
const proto = window.HTMLIFrameElement?.prototype;
const desc = proto && Object.getOwnPropertyDescriptor(proto, 'srcdoc');

if (proto && desc?.get && desc?.set && !proto.__hbLedgerBrowserFooterFix) {
  Object.defineProperty(proto, 'srcdoc', {
    configurable: desc.configurable,
    enumerable: desc.enumerable,
    get: desc.get,
    set(value) {
      let next = value;
      if (typeof next === 'string' && /class="head"/.test(next) && /Ledger|Account Statement/i.test(next)) {
        const css = `<style id="hb-ledger-browser-footer-fix">
          @page { size: A4; margin: 0 !important; }
          @media print {
            html, body { margin: 0 !important; }
            html body { padding: 9mm !important; }
          }
        </style>`;
        next = next.includes('</head>') ? next.replace('</head>', `${css}</head>`) : `${css}${next}`;
      }
      return desc.set.call(this, next);
    },
  });
  Object.defineProperty(proto, '__hbLedgerBrowserFooterFix', { value: true });
}
